import Mind from './components/Mind';
import { useState, useRef } from 'react';
import { ReloadOutlined } from '@ant-design/icons';
import MyIcon from '@/components/MyIcon';
import { Mask } from 'antd-mobile';
import GrtButton from '../GrtButton';
import './index.scss';
const MobileMind = (props) => {
    const [isDownLoad, setIsDownLoad] = useState(false);
    const mindRef = useRef<any>(null);
    const [open, setOpen] = useState(false);
    const download = () => {
        setIsDownLoad(true);
        mindRef.current?.download();
    };
    const afterDownload = () => {
        setIsDownLoad(false);
    };
    return (
        <>
            <Mask destroyOnClose={true} visible={open} onMaskClick={() => setOpen(false)}>
                <div className="mobile-modal-mind-box">
                    <div className="mobile-modal-mind-tool-bar">
                        <div onClick={() => setOpen(false)} className="close">
                            关闭
                        </div>
                        <div className="action" onClick={download}>
                            <GrtButton
                                loading={isDownLoad}
                                loadingIcon={<ReloadOutlined style={{ marginRight: 5 }} spin />}
                                loadingText="下载图片"
                                color="primary"
                            >
                                下载图片
                            </GrtButton>
                        </div>
                    </div>
                    <Mind
                        ref={mindRef}
                        {...props}
                        afterDownload={afterDownload}
                        inModal={true}
                        pan={true}
                        zoom={true}
                        rootClassName="modal-svg-root"
                        className="modal-svg"
                    ></Mind>
                </div>
            </Mask>
            {/* <Modal
                afterOpenChange={() => {
                    mindRef.current?.refMm?.current?.fit();
                }}
                destroyOnClose={true}
                footer={null}
                closable={false}
                width={1000}
                open={open}
                onCancel={() => setOpen(false)}
                onOk={() => setOpen(false)}
            >
               
            </Modal> */}

            <div className="mobile-mind-box-wrap">
                <Mind {...props} pan={false} zoom={false} setOpen={setOpen}></Mind>
            </div>
        </>
    );
};
export default MobileMind;
